import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./LinkModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import CheckBoxItem from "../../Shared/CheckBoxItem";
import InfoItem from "shared/InfoItem";

/**
 * Interactive component. Modal used for linking an account.
 */

export function LinkModal({
  isOpen,
  onClose,
  onClick,
  memberID,
  dsId,
  checked,
}) {
  const [isSendChecked, setIsSendChecked] = useState(false);

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="LINK"
        closeBtn="none"
        className={styles.modal}
      >
        <div className={styles.contentContainer}>
          <div className={styles.infoDiv}>
            <InfoItem label="WWG Membership ID:" description={memberID} />
          </div>
          <div className={styles.infoDiv1}>
            <InfoItem label="DreamStream ID:" description={dsId} />
          </div>
          <div className={styles.checkboxContainer}>
            <CheckBoxItem
              checked={isSendChecked}
              name="Send a new invite email with the user's latest access code"
              onClick={() => {
                setIsSendChecked(!isSendChecked);
              }}
            />
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <div className={styles.btnDiv}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className={styles.connectBtn}
                  onClick={onClick}
                >
                  CONNECT
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

LinkModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when create all is clicked
   */
  onClick: PropTypes.func,
  /**
   * WWG Membership ID
   */
  memberID: PropTypes.string,
  /**
   * DreamStream ID
   */
  dsId: PropTypes.string,
  /**
   * 	True if checkbox is checked
   */
  checked: PropTypes.bool,
};
